module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_vm._v("“The rest of my speech” (he explained to his men)")])]), _c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“You shall hear when I’ve leisure to speak it,")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("But the Snark is at hand, let me tell you again!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("’Tis your glorious duty to seek it!")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“To seek it with thimbles, to seek it with care;")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To pursue it with forks and hope;")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("To threaten its life with a railway share;")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To charm it with smiles and soap!")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“For the Snark’s a peculiar creature, that won’t")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Be caught in a commonplace way. ")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Do all that you know, and try all that you don’t:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not a chance must be wasted to-day!”")]), _vm._v(" "), _c('p', {
    staticClass: "epi",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Lewis Carroll")]), _vm._v(" "), _c('p', {
    staticClass: "epi2"
  }, [_c('i', [_vm._v("The Hunting of the Snark")])]), _vm._v(" "), _c('p', {
    staticClass: "epi2"
  }, [_vm._v("An Agony in Eight Fits (1876)")]), _vm._v(" "), _c('p', {
    staticClass: "epi2"
  }, [_vm._v("Fit the Fourth")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7076db82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5start.vue
// module id = 72
// module chunks = 0